<template>
    <div>
        <div class="row">
            <div class="col-lg-12 mb-3">
                <b-breadcrumb :items="breadcrumbItems" class="breadcrumb1 breadcrumbCustom border"/>
                <b-card :header="$t('general.teams.team_members.title')" header-tag="h3" class="bg-default-card">
                    <div>
                        <data-table
                            v-if="tableLoaded"
                            :exportable = "false"
                            title=""
                            :rows="getData.rowData"
                            :columns="columnData"
                            :perPage="perPage"
                            :rowsCount="rowsCount"
                            :currentPage="currentPage"
                            :pageCount="pageCount"
                            @rowClickDelete="onDeleteRow"
                            @rowClickEdit="onEditRow"
                            @changePage="changePage"
                            @searchEvent="searchEvent"
                            @orderByEvent="orderByEvent"
                            >
                        </data-table>
                    </div>

                    <b-btn class="btn btn-dark mt-3" @click="returnToTeams">
                        <i class="fa fa-arrow-left" aria-hidden="true"></i> {{$t('general.buttons.return_to.return_to_teams')}}
                    </b-btn>
    
                    <b-btn type="button" class="btn btn-secondary ml-1 mt-3" @click="onAddRow" v-if="this.$store.getters.hasPermission(['project_teams'], ['update'])">
                        <i class="fa fa-plus-circle"></i> {{$t('general.teams.team_members.add_user')}}
                    </b-btn>
                </b-card>
            </div>
        </div>

        <b-modal :ok-title="$t('misc.ok')" :cancel-title="$t('misc.cancel')" ref="teamModal" id="teamModal" :title="actionTitle" size="md" @ok="saveAction" :ok-disabled="$store.state.ajax_in_progress || (row && !$store.getters.hasPermission(['project_teams'], ['update']))">
            <div class="row">
                <div class="col-sm-12">
                    <label>{{$t('table.team_member')}}</label>
                    <div class="mb-3" v-if="row == null">
                        <multiselect v-model="selectedUser"
                            :options="currentUser"
                            :multiple="false"
                            :clear-on-select="true"
                            :hide-selected="false"
                            :loading="isUserLoading"
                            :preserve-search="true"
                            placeholder=""
                            label="fullname" track-by="id"
                            :selectLabel="''"
                            @search-change="onUserSearch"
                            @input="updateUser"
                        >
                            <template slot="clear" slot-scope="props">
                                <div 
                                    v-if="selectedUser != null" 
                                    class="multiselect__clear" 
                                    @mousedown.prevent.stop="clearSelectedUser"
                                >
                                </div>
                            </template>
                            <span slot="noOptions">{{ $t('modal.general.list_is_empty') }}</span>
                            <span slot="noResult">{{ $t('modal.general.no_results') }}</span>
                        </multiselect>
                    </div>

                    <label>{{$t('table.title')}}</label>
                    <input type="text" maxlength="50" class="form-control" v-model="model.title">

                    <div class="mt-3">
                        <label>{{$t('table.is_boss')}}</label>
                        <toggle-button class="mt-1 ml-1" style="z-index: 0;" :value="false" :sync="true" :color="{checked: '#75C791', unchecked: '#dc6460'}" :labels="{checked: $t('misc.yes'), unchecked: $t('misc.no')}" v-model="model.is_boss"/>
                    </div>
                </div>
            </div>
        </b-modal>

        <confirm-dialog ref="deleteModal" :title="actionTitle" @buttonClick="deleteAction">
            {{ $t('messages.delete') }}
        </confirm-dialog>
    </div>
</template>

<script>
    import Vue from 'vue';
    import * as notificationIcons from '@/components/global/miscellaneous/notificationIcons.js';
    import http from '@/libs/http';
    import miniToastr from 'mini-toastr';
    import DataTable from '@/components/global/tables/datatables/DataTable.vue';
    import ConfirmDialog from '@/components/global/modals/ConfirmDialog.vue';

    import VeeValidate from 'vee-validate';
    Vue.use(VeeValidate);

    import { Validator } from 'vee-validate';

    import Multiselect from 'vue-multiselect';
    Vue.component(Multiselect);

    import ToggleButton from 'vue-js-toggle-button';
    Vue.use(ToggleButton);

    export default {
        name: 'team_members',
        components: {
            Multiselect,
            DataTable,
            VeeValidate,
            ConfirmDialog,
            notificationIcons,
        },
        data() {
            return {
                breadcrumbItems: [
                    {
                        text: Vue.i18n.translate('general.dashboard.title'),
                        to: '/',
                    },
                    {
                        text: Vue.i18n.translate('general.projects.title_modal') + ': ' + this.$store.state.current_project.name,
                        to: '/project/'+this.$route.params.id,
                    },
                    {
                        text: Vue.i18n.translate('general.teams.title'),
                        active: true
                    },
                    {
                        text: Vue.i18n.translate('general.teams.team_members.title'),
                        active: true
                    }
                ],
                tableName: 'team',
                tableNameTranslated: Vue.i18n.translate('general.teams.team_members.title_modal'),
                row: null,
                tableLoaded: false,
                perPage: 0,
                pageCount: 1,
                rowsCount: 0,
                currentPage: 1,
                sortType: 'asc',
                sortBy: 'id',
                searchInput: '',
                actionTitle: '',

                selectedUser: null,
                currentUser: [],
                isUserLoading: false,

                getData: {
                    rowData: [],
                    getUsers: []
                },
                model: {
                    title: null,
                    is_boss: null,
                    user_id: null,
                },
                columnData: [
                    {
                        label: Vue.i18n.translate('misc.actions'),
                        width: '90px',
                        field: '',
                        showDeleteButton: true,
                        showEditButton: true,
                    },
                    {
                        label: Vue.i18n.translate('table.name'),
                        field: 'fullname',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.title'),
                        field: 'title',
                        numeric: false,
                        html: false,
                    },
                    {
                        label: Vue.i18n.translate('table.is_boss'),
                        field: 'is_boss',
                        numeric: false,
                        html: false,
                    }
                ]
            }
        },
        mounted() {
            this.onLoadTable();
        },
        methods: {
            returnToTeams () {
                this.$router.push({name: 'teams'});
            },
            orderByEvent (column, sort_type) {
                this.sortType = sort_type;
                this.sortBy = column.field;
                this.onLoadTable();
            },
            searchEvent (searchInput) {
                this.searchInput = searchInput;
                this.onLoadTable();
            },
            successMsg(msg) {
                miniToastr.success(msg, Vue.i18n.translate('messages.success'), 5000);
            },
            errorMsg(msg) {
                miniToastr.error(msg, Vue.i18n.translate('messages.error'), 5000);
            },
            changePage (page) {
                this.currentPage = page;
                this.onLoadTable();
            },
            onLoadTable () {
                http.route('team/'+this.$route.params.idm+'/members?get_all=1&search=' + this.searchInput + '&page=' + this.currentPage + '&sort_by=' + this.sortBy + '&sort_order=' + this.sortType).get().then(response => {
                    if (!response.isError) {
                        this.perPage = response.pagination.limit;
                        this.rowsCount = response.pagination.totalEntries;
                        this.currentPage = response.pagination.currentPage;
                        this.pageCount = response.pagination.totalPages;
                        var data = response.data;
                        data.forEach(field => {
                            field.is_boss = (field.is_boss == 1) ? Vue.i18n.translate('misc.yes') : Vue.i18n.translate('misc.no');
                            field.fullname = field.user.firstname + ' ' + field.user.lastname;
                        });
                        this.getData.rowData = data;
                        this.tableLoaded = true;
                    } else {
                        Object.keys(response.errorMessage).forEach(key => {
                            this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                        });
                    }
                });
            },
            clearSearches () {
                this.currentUser  = [];
                this.selectedUser = null;
            },
            onAddRow () {
                this.actionTitle = Vue.i18n.translate('modal.general.create') + ' ' + this.tableNameTranslated;
                this.clearSearches();
                this.row = null;
                this.model.title = null;
                this.model.is_boss = false;
                this.$refs.teamModal.show();
            },
            onEditRow (row) {
                this.actionTitle = Vue.i18n.translate('modal.general.edit') + ' ' + this.tableNameTranslated;
                this.row = row;
                this.model.title = row.title;
                this.model.is_boss = (row.is_boss === Vue.i18n.translate('misc.yes'));
                this.$refs.teamModal.show();
            },
            onDeleteRow (row, index) {
                this.actionTitle = Vue.i18n.translate('modal.general.delete') + ' ' + this.tableNameTranslated;
                this.row = row;
                this.$refs.deleteModal.show();
            },
            onUserRow(row, index) {
                this.$router.push({name: 'team_members', params: {id: row.id}});
            },
            saveAction (e) {
                e.preventDefault();

                let put_data = {
                    title: this.model.title,
                    is_boss: this.model.is_boss,
                };

                Object.keys(put_data).forEach(key => {
                    if (put_data[key] === '') {
                        put_data[key] = null;
                    }
                });

                if (this.row) {
                    http.route('team/'+this.$route.params.idm+'/members/'+this.row.id).patch(put_data, true).then(response => {
                        if (response.isError) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.updated'));
                            this.$refs.teamModal.hide();
                        }
                    });
                } else {
                    http.route('team/'+this.$route.params.idm+'/members/'+this.selectedUser.id).post(put_data, true).then(response => {
                        if (response.isError) {
                            Object.keys(response.errorMessage).forEach(key => {
                                this.errorMsg(Vue.i18n.translate(response.errorMessage[key]));
                            });
                        } else {
                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.created'));
                            this.$refs.teamModal.hide();
                        }
                    });
                }
            },
            deleteAction (button) {
                if (button == 1) {
                    let data = http.route('team/'+this.$route.params.idm+'/members/'+this.row.id).delete();
                    data.then(response => {
                        if (response.isError == false) {
                            if (this.currentPage > 1 && this.getData.rowData.length == 1) {
                                this.currentPage = this.currentPage - 1;
                            }

                            this.onLoadTable();
                            this.successMsg(this.tableNameTranslated + Vue.i18n.translate('messages.deleted'));
                        } else {
                            this.errorMsg(Vue.i18n.translate('errors.error_delete'));
                        }
                    });
                }
                this.$refs.deleteModal.hide();
            },
            onUserSearch(search) {
                if (search == '') {
                    this.currentUser = [];
                    
                    return false;
                }

                this.isUserLoading = true;
                this.searchUser(search, this);
            },
            searchUser: _.debounce((search, vm) => {
                let data = http.route('user/getall?filters[project_id]='+vm.$route.params.id+'&filters[not_in_team]='+vm.$route.params.idm + '&search_select=' + search).get();
                data.then(response => {
                    if (response.data != false) {
                        vm.currentUser = response.data;
                    }
                    vm.isUserLoading = false;
                });
            }, 500),
            updateUser(user) {
                this.model.user_id = (user != null) ? user.id : null;
            },
            clearSelectedUser () {
                this.selectedUser  = null;
                this.model.user_id = null;
            },
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>


// WEBPACK FOOTER //
// src/components/pages/project/teams/team_members.vue